var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error",
    transform: "translate(-87.482 -154.879)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scanning_icn",
    transform: "translate(87.766 154.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24917",
    "data-name": "Path 24917",
    d: "M0,41.849A41.84,41.84,0,1,0,41.84,0,41.849,41.849,0,0,0,0,41.849Z",
    transform: "translate(0 0)",
    fill: "#bce0fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "id-card",
    transform: "translate(9.83 20.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16847",
    "data-name": "Path 16847",
    d: "M69.019,260.673c-10.988,0-9.769,13.363-9.719,23.047a1.034,1.034,0,0,0,.507.884,18.544,18.544,0,0,0,18.425,0,1.034,1.034,0,0,0,.507-.884C78.789,274.036,80.007,260.673,69.019,260.673Z",
    transform: "translate(-53.678 -251.787)",
    fill: "#694b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16860",
    "data-name": "Path 16860",
    d: "M81.461,313.655l.431,4.091a2.777,2.777,0,0,0,1.417,2.176l3.953,2.2a2.073,2.073,0,0,0,1.413.211h0s-1.993-.6-3.179-3.815c-.363-.983-.868-6.19-.434-6.827.857-1.258,5.64-1.389,7.053-3.722q-.1-.13-.193-.26l-.015-.021a2.674,2.674,0,0,1-.164-.278C88.273,310.878,81.461,308.1,81.461,313.655Z",
    transform: "translate(-72.931 -292.273)",
    fill: "#f6d2bf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11509",
    "data-name": "Group 11509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16845",
    "data-name": "Path 16845",
    d: "M79.021,236.694H20.015a2.36,2.36,0,0,1-2.36-2.36V196.567a2.36,2.36,0,0,1,2.36-2.36H79.021a2.36,2.36,0,0,1,2.36,2.36v37.767A2.36,2.36,0,0,1,79.021,236.694Z",
    transform: "translate(-17.655 -194.207)",
    fill: "#1a8cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16846",
    "data-name": "Path 16846",
    d: "M66.56,271.39H45.318a1.18,1.18,0,0,1-1.18-1.18V239.524a1.18,1.18,0,0,1,1.18-1.18H66.56a1.18,1.18,0,0,1,1.18,1.18V270.21A1.18,1.18,0,0,1,66.56,271.39Z",
    transform: "translate(-40.598 -232.443)",
    fill: "#0063f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16848",
    "data-name": "Path 16848",
    d: "M68.316,260.879c-10.219.573-9.06,13.551-9.011,23.019a1.034,1.034,0,0,0,.507.884,18.21,18.21,0,0,0,9.213,2.45L71.8,267.794",
    transform: "translate(-53.682 -251.965)",
    fill: "#013272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16849",
    "data-name": "Path 16849",
    d: "M89.116,260.673c-6.248,0-6.682,7.55-6.682,7.55,3.6-.608,5.814.911,9.458-.608l-2.777,19.439a18.21,18.21,0,0,0,9.213-2.45,1.034,1.034,0,0,0,.507-.884C98.885,274.036,100.1,260.673,89.116,260.673Z",
    transform: "translate(-73.774 -251.787)",
    fill: "#013b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16850",
    "data-name": "Path 16850",
    d: "M166.779,288.607c.043-8.321.941-19.351-5.776-22.292a6.169,6.169,0,0,0,.222,3.411c1.388,2.777,2.777,2.777,4.165,4.86,1.388,7.637-2.653,15.742-4,16.845h0a17.462,17.462,0,0,0,4.877-1.94A1.035,1.035,0,0,0,166.779,288.607Z",
    transform: "translate(-141.718 -256.674)",
    fill: "#00429a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16851",
    "data-name": "Path 16851",
    d: "M66.459,412.908l-6.194-2.581a1.389,1.389,0,0,1-.854-1.282v-1.678H52.468v1.678a1.388,1.388,0,0,1-.854,1.282l-6.194,2.581a2.083,2.083,0,0,0-1.282,1.923v1.805a1.18,1.18,0,0,0,1.18,1.18H66.56a1.18,1.18,0,0,0,1.18-1.18v-1.805A2.083,2.083,0,0,0,66.459,412.908Z",
    transform: "translate(-40.598 -378.869)",
    fill: "#f6d2bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16852",
    "data-name": "Path 16852",
    d: "M66.459,432.638l-5.989-2.5-4.53,1.956-4.53-1.956-5.989,2.5a2.083,2.083,0,0,0-1.282,1.922v1.805a1.18,1.18,0,0,0,1.18,1.18H66.56a1.18,1.18,0,0,0,1.18-1.18V434.56A2.083,2.083,0,0,0,66.459,432.638Z",
    transform: "translate(-40.598 -398.599)",
    fill: "#fc6fd0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16853",
    "data-name": "Path 16853",
    d: "M101.588,407.367H94.646v1.678a1.388,1.388,0,0,1-.854,1.282l-.967.4C100.227,412.617,101.588,407.367,101.588,407.367Z",
    transform: "translate(-82.775 -378.869)",
    fill: "#f0c3ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5285",
    "data-name": "Group 5285",
    transform: "translate(3.54 30.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16854",
    "data-name": "Path 16854",
    d: "M47.522,454.535l-2.786-2.217a2.079,2.079,0,0,0-.6,1.454v1.8a1.18,1.18,0,0,0,1.18,1.18H48.3v-.6A2.07,2.07,0,0,0,47.522,454.535Z",
    transform: "translate(-44.138 -448.217)",
    fill: "#fc98dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16855",
    "data-name": "Path 16855",
    d: "M193.7,455.633v-1.805a2.078,2.078,0,0,0-.588-1.445l-2.8,2.208a2.083,2.083,0,0,0-.782,1.626v.6h2.985A1.18,1.18,0,0,0,193.7,455.633Z",
    transform: "translate(-170.098 -448.274)",
    fill: "#fc98dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16856",
    "data-name": "Path 16856",
    d: "M128.019,449.046h-.208a.59.59,0,0,1-.59-.59V444.78h1.388v3.676A.59.59,0,0,1,128.019,449.046Z",
    transform: "translate(-116.114 -441.687)",
    fill: "#fc98dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16857",
    "data-name": "Path 16857",
    d: "M96.426,424.738l-3.973-2.98a.555.555,0,0,0-.8.136l-.785,1.178,2.436,3.411a.555.555,0,0,0,.8.111Z",
    transform: "translate(-84.624 -421.647)",
    fill: "#fc98dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16858",
    "data-name": "Path 16858",
    d: "M132.414,424.738l3.973-2.98a.555.555,0,0,1,.8.136l.785,1.178-2.436,3.411a.555.555,0,0,1-.8.111Z",
    transform: "translate(-120.613 -421.647)",
    fill: "#fc98dd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16859",
    "data-name": "Path 16859",
    d: "M91.743,307.407c-3.471,3.471-10.283.694-10.283,6.248l.431,4.091a2.777,2.777,0,0,0,1.417,2.176l3.953,2.2a2.082,2.082,0,0,0,2.023,0l3.953-2.2a2.777,2.777,0,0,0,1.417-2.176l.5-4.859a7.665,7.665,0,0,0,.031-1.039C94.922,310.081,92.437,308.8,91.743,307.407Z",
    transform: "translate(-72.93 -292.273)",
    fill: "#f7ded0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6718",
    "data-name": "Group 6718",
    transform: "translate(31.863 8.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5286",
    "data-name": "Group 5286",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16861",
    "data-name": "Path 16861",
    d: "M276.062,258.36H257.18a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h18.882a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,276.062,258.36Z",
    transform: "translate(-256 -255.999)",
    fill: "#61b5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16862",
    "data-name": "Path 16862",
    d: "M281.963,293.671H257.18a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h24.782a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,281.963,293.671Z",
    transform: "translate(-256 -286.589)",
    fill: "#61b5fc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_16863",
    "data-name": "Path 16863",
    d: "M259.54,373.119h-2.36a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h2.36a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,259.54,373.119Z",
    transform: "translate(-256 -355.415)",
    fill: "#61b5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16864",
    "data-name": "Path 16864",
    d: "M324.307,373.119H310.145a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h14.161a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,324.307,373.119Z",
    transform: "translate(-301.884 -355.415)",
    fill: "#61b5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16865",
    "data-name": "Path 16865",
    d: "M259.54,408.429h-2.36a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h2.36a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,259.54,408.429Z",
    transform: "translate(-256 -386.005)",
    fill: "#61b5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16866",
    "data-name": "Path 16866",
    d: "M327.847,408.429h-17.7a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h17.7a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,327.847,408.429Z",
    transform: "translate(-301.884 -386.005)",
    fill: "#61b5fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16867",
    "data-name": "Path 16867",
    d: "M259.54,443.739h-2.36a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h2.36a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,259.54,443.739Z",
    transform: "translate(-256 -416.594)",
    fill: "#61b5fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5287",
    "data-name": "Group 5287",
    transform: "translate(7.081 24.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16868",
    "data-name": "Path 16868",
    d: "M319.586,443.739h-9.441a1.18,1.18,0,0,1-1.18-1.18h0a1.18,1.18,0,0,1,1.18-1.18h9.441a1.18,1.18,0,0,1,1.18,1.18h0A1.18,1.18,0,0,1,319.586,443.739Z",
    transform: "translate(-308.965 -441.378)",
    fill: "#61b5fc"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24912",
    "data-name": "Path 24912",
    d: "M81.461,313.655l.431,4.091a2.777,2.777,0,0,0,1.417,2.176l3.953,2.2a2.073,2.073,0,0,0,1.413.211h0s-1.993-.6-3.179-3.815c-.363-.983-.868-6.19-.434-6.827.857-1.258,5.64-1.389,7.053-3.722q-.1-.13-.193-.26l-.015-.021a2.674,2.674,0,0,1-.164-.278C88.273,310.878,81.461,308.1,81.461,313.655Z",
    transform: "translate(-72.931 -292.272)",
    fill: "#f6d2bf"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_24916",
    "data-name": "Path 24916",
    d: "M0,0,82.789,0A46.111,46.111,0,0,1,78.11,14.408,52.047,52.047,0,0,1,68.095,26.533a41.222,41.222,0,0,1-26.034,9.656,44.9,44.9,0,0,1-26.756-9.078S8.6,21.338,4.77,14.561A44.505,44.505,0,0,1,0,0Z",
    transform: "translate(0.474 47.617)",
    fill: "#fc6fd0",
    opacity: 0.477
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24915",
    "data-name": "Path 24915",
    d: "M-.473-.039,83.242,0s-.017,1.479-.146,3.229-.428,3.77-.428,3.77L.068,7S-.22,5.007-.355,3.248-.473-.039-.473-.039Z",
    transform: "translate(0.474 41.617)",
    fill: "#fc6fd0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_25055",
    "data-name": "Path 25055",
    d: "M42,0A42,42,0,1,1,0,42,42,42,0,0,1,42,0Z",
    transform: "translate(87.482 154.879)",
    fill: "#ff88ac",
    opacity: 0.897
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11673",
    "data-name": "Group 11673",
    transform: "translate(112.89 178.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(-9.717 -7.567)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19272",
    "data-name": "Path 19272",
    d: "M52.837,65.325l-19.059-31.9a7.925,7.925,0,0,0-13.606,0L1.112,65.325A7.9,7.9,0,0,0,1.049,73.3a7.807,7.807,0,0,0,6.866,3.987H46.034A7.807,7.807,0,0,0,52.9,73.3,7.9,7.9,0,0,0,52.837,65.325Z",
    transform: "translate(0 -29.569)",
    fill: "#f83d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19273",
    "data-name": "Path 19273",
    d: "M281.926,73.3a7.807,7.807,0,0,1-6.866,3.987H256V29.57a7.9,7.9,0,0,1,6.8,3.86l19.059,31.9A7.9,7.9,0,0,1,281.926,73.3Z",
    transform: "translate(-229.026 -29.57)",
    fill: "#eb1154"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19274",
    "data-name": "Path 19274",
    d: "M34.752,100.987A4.625,4.625,0,0,1,30.636,98.6a4.716,4.716,0,0,1,.049-4.817l19.041-31.87a4.763,4.763,0,0,1,8.182.022L76.954,93.805a4.706,4.706,0,0,1,.034,4.793,4.625,4.625,0,0,1-4.116,2.389H34.752Z",
    transform: "translate(-26.838 -56.434)",
    fill: "#ff5d8f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19275",
    "data-name": "Path 19275",
    d: "M275.059,100.986a4.625,4.625,0,0,0,4.116-2.389,4.706,4.706,0,0,0-.034-4.793L260.1,61.932A4.765,4.765,0,0,0,256,59.6v41.389Z",
    transform: "translate(-229.025 -56.433)",
    fill: "#f83d77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19276",
    "data-name": "Path 19276",
    d: "M232.3,125.228v12.657a3.164,3.164,0,0,1-6.328,0V125.228a3.164,3.164,0,1,1,6.328,0Z",
    transform: "translate(-202.159 -112.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19277",
    "data-name": "Path 19277",
    d: "M259.164,125.228v12.657A3.173,3.173,0,0,1,256,141.049V122.064A3.174,3.174,0,0,1,259.164,125.228Z",
    transform: "translate(-229.026 -112.318)",
    fill: "#ddf0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19278",
    "data-name": "Path 19278",
    d: "M215.7,332.278a4.746,4.746,0,1,0,4.746,4.746A4.74,4.74,0,0,0,215.7,332.278Z",
    transform: "translate(-188.726 -300.382)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19279",
    "data-name": "Path 19279",
    d: "M260.746,337.024A4.74,4.74,0,0,1,256,341.771v-9.493A4.74,4.74,0,0,1,260.746,337.024Z",
    transform: "translate(-229.026 -300.382)",
    fill: "#ddf0ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0881bb05882c4bc356ee258a1b98657a.svg";
export { ForwardRef as ReactComponent };